import {useCallback} from 'react'

import {useMappedState} from 'redux-react-hook'

function useScale () {
  const mapState = useCallback(
    state => ({
      scale: state.scale
    }),
    []
  )

  const {scale} = useMappedState(mapState)
  return scale
}

export default useScale
